import {
  SUGERENCIA_ERROR,
  SUGERENCIA_LOADING,
  SUGERENCIA_SUCCESS,
  SUGERENCIA_RESET,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";

import sugerenciaInitialState from "../initialStates/sugerenciaInitialState";

const sugerencia = (state, { payload, type }) => {
  switch (type) {
    case SUGERENCIA_LOADING:
      return {
        ...state,
        sugerencia: {
          ...state.sugerencia,
          error: false,
          loading: true,
        },
      };
    case SUGERENCIA_SUCCESS:
      return {
        ...state,
        sugerencia: {
          ...state.sugerencia,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case SUGERENCIA_ERROR:
      return {
        ...state,
        sugerencia: {
          ...state.sugerencia,
          error: payload,
          loading: false,
        },
      };

    case SUGERENCIA_RESET:
      return sugerenciaInitialState;
    case RESET_PORTAL_CONTEXT:
      return sugerenciaInitialState;

    default:
      return state;
  }
};

export default sugerencia;
